/* HELEN CUSTOM — ô cá nhân hoá riêng của Helen (thay app TEPO/Qikify). Nguồn: shopify-custom/ trong workspace.
 * Việc của file này (không thư viện, không gọi máy chủ nào ngoài chính Shopify):
 *  1. Ẩn/hiện ô theo lựa chọn của khách, đếm chữ, xem trước ảnh upload, hiện tiền phụ thu + tổng.
 *  2. Bấm "Thêm vào giỏ" (nút chính, thanh mua dính, Enter): kiểm ô bắt buộc → thêm SP chính (kèm ảnh upload,
 *     Shopify tự lưu ảnh) → thêm các dòng phụ thu → mở ngăn giỏ của theme. Dòng phụ thu lỗi thì gỡ SP chính (không để giỏ thiếu tiền).
 *  3. Khách sửa/xoá SP chính trong giỏ → dòng phụ thu tự khớp theo (không để phụ thu mồ côi hay lệch số lượng).
 */
(function () {
  'use strict';
  if (window.__helenCustom) return;
  window.__helenCustom = true;
  var D = document, W = window;
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var U_ADD = ROOT + 'cart/add.js', U_CHANGE = ROOT + 'cart/change.js', U_UPDATE = ROOT + 'cart/update.js', U_CART = ROOT + 'cart.js';
  var FLAG = 'hc_cart';
  var blocks = [];

  function all(sel, el) { return Array.prototype.slice.call((el || D).querySelectorAll(sel)); }
  function isFile(v) { return v && typeof v === 'object' && typeof v.size === 'number' && typeof v.name === 'string'; }

  /* ---------- tiền: cents theo tiền khách đang xem ---------- */
  function rate() { var c = W.Shopify && W.Shopify.currency; return c && c.rate ? parseFloat(c.rate) || 1 : 1; }
  function money(cents) {
    var cur = (W.Shopify && W.Shopify.currency && W.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(D.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- đọc giá trị 1 ô ---------- */
  function vals(f) {
    var t = f.getAttribute('data-t'), x;
    if (t === 'textarea' || t === 'text') { x = f.querySelector('textarea,input[type=text]'); return x && x.value.trim() ? [x.value.trim()] : []; }
    if (t === 'select') { x = f.querySelector('select'); return x && x.value ? [x.value] : []; }
    if (t === 'upload') { x = f.querySelector('input[type=file]'); return x && x.files && x.files.length ? [x.files[0].name] : []; }
    if (t === 'group') return [];
    return all('.hc-sw input:checked,.hc-rs input:checked', f).map(function (i) { return i.value; });
  }
  function shown(f) { // ô đang hiện (tính cả nhóm cha)
    for (var el = f; el && !el.hasAttribute('data-hc'); el = el.parentElement) if (el.hidden) return false;
    return true;
  }

  /* ---------- 1 khối custom trên trang SP ---------- */
  function Block(el) {
    var self = this;
    this.el = el;
    this.formId = el.getAttribute('data-form');
    if (!D.getElementById(this.formId)) { // tên form khác dự kiến → tự tìm form SP rồi nối lại mọi ô
      var alt = D.querySelector('form[data-type="add-to-cart-form"][data-productid="' + el.getAttribute('data-hc') + '"]') || D.querySelector('form[action*="/cart/add"]');
      if (alt) {
        if (!alt.id) alt.id = 'hc-form-' + el.getAttribute('data-hc');
        this.formId = alt.id;
        all('[form]', el).forEach(function (i) { i.setAttribute('form', alt.id); });
      }
    }
    this.title = el.getAttribute('data-title') || '';
    this.fields = all('[data-hc-f]', el);
    this.byId = {};
    this.fields.forEach(function (f) { self.byId[f.getAttribute('data-hc-f')] = f; });
    try { this.prices = JSON.parse((el.querySelector('[data-hc-prices]') || {}).textContent || '{}'); } catch (e) { this.prices = {}; }
    el.addEventListener('change', function (e) { self.onChange(e); });
    el.addEventListener('input', function (e) {
      var f = e.target.closest('[data-hc-f]');
      if (f) { self.counter(f); self.err(f, ''); }
    });
    var form = this.form();
    if (form) {
      form.classList.add('hc-form');
      // Nút thanh toán nhanh của Shopify bỏ qua dòng phụ thu → bị ẩn (CSS). Thay bằng nút "Buy it now" của mình:
      // bấm = kiểm ô + thêm SP chính + dòng phụ thu như nút giỏ, rồi sang thẳng trang thanh toán (ở đó vẫn có Shop Pay/Apple Pay…).
      var pb = form.querySelector('.shopify-payment-button');
      if (pb && !form.querySelector('[data-hc-buynow]')) {
        var wrap = D.createElement('div');
        wrap.className = 'hc-pb';
        wrap.innerHTML = '<button type="button" class="hc-buynow" data-hc-buynow>Buy it now</button>';
        pb.parentNode.insertBefore(wrap, pb.nextSibling);
      }
      form.addEventListener('change', function () { self.total(); });
      form.addEventListener('click', function (e) { if (e.target.closest('[data-quantity-selector]')) setTimeout(function () { self.total(); }, 0); });
    }
    this.fields.forEach(function (f) { self.counter(f); self.big(f); });
    this.refresh();
    var nojs = el.querySelector('[data-hc-nojs]');
    if (nojs) nojs.parentNode.removeChild(nojs);
    el.classList.add('hc-ready');
  }
  Block.prototype.form = function () { return D.getElementById(this.formId); };
  Block.prototype.onChange = function (e) {
    var f = e.target.closest('[data-hc-f]');
    if (!f) return;
    var t = f.getAttribute('data-t');
    if (t === 'checks') {
      var mx = +f.getAttribute('data-mx') || 0, j = f.querySelector('[data-hc-join]');
      if (mx && e.target.checked && vals(f).length > mx) { // như TEPO: không cho chọn quá số tối đa
        e.target.checked = false;
        if (j) j.value = vals(f).join(', ');
        this.refresh();
        this.err(f, 'You can choose up to ' + mx + ' options.');
        return;
      }
      if (j) j.value = vals(f).join(', ');
    }
    if (t === 'upload') this.upload(f, e.target);
    if (t === 'swatch') this.big(f);
    this.err(f, '');
    this.refresh();
  };
  Block.prototype.refresh = function () {
    var self = this, pass, changed;
    for (pass = 0; pass < 20; pass++) { // ẩn/hiện theo điều kiện, lặp tới khi ổn định (ô ẩn kéo theo ô phụ thuộc nó)
      changed = false;
      this.fields.forEach(function (f) {
        var c = f.getAttribute('data-if');
        if (!c) return;
        try { c = JSON.parse(c); } catch (e) { return; }
        var hits = c.c.map(function (p) { var g = self.byId[p[0]]; return !!g && shown(g) && vals(g).indexOf(p[1]) > -1; });
        var show = c.m === 'all' ? hits.every(Boolean) : hits.some(Boolean);
        if (f.hidden === show) { f.hidden = !show; changed = true; }
      });
      if (!changed) break;
    }
    this.fields.forEach(function (f) { // ô ẩn = khoá ô nhập → không lọt vào giỏ
      if (f.getAttribute('data-t') === 'group') return;
      if (f.getAttribute('data-t') === 'checks') { var jn = f.querySelector('[data-hc-join]'); if (jn) jn.value = vals(f).join(', '); } // kể cả ô tích sẵn chưa ai bấm
      var off = !shown(f);
      all('input,select,textarea', f).forEach(function (i) { if (!i.classList.contains('hc-mt')) i.disabled = off; });
      var v = f.querySelector('[data-hc-val]');
      if (v) { var x = vals(f); v.textContent = x.length ? ': ' + x.join(', ') : ''; }
    });
    this.total();
  };
  Block.prototype.counter = function (f) {
    var c = f.querySelector('[data-hc-cnt]'), x = f.querySelector('textarea,input[type=text]');
    if (c && x) c.textContent = x.value.length + '/' + (x.getAttribute('maxlength') || '');
  };
  Block.prototype.big = function (f) { // ảnh lớn của mẫu đang chọn
    var b = f.querySelector('[data-hc-big]');
    if (!b) return;
    var i = f.querySelector('.hc-sw input:checked'), im = i && i.parentNode.querySelector('img');
    if (!im) { b.hidden = true; return; }
    b.src = im.getAttribute('src').replace(/width=\d+/, 'width=480');
    b.alt = i.value;
    b.hidden = false;
  };
  Block.prototype.upload = function (f, input) {
    var file = input.files && input.files[0], prev = f.querySelector('[data-hc-prev]');
    if (!file) { if (prev) prev.hidden = true; return; }
    if (file.type && !/^image\//.test(file.type)) { input.value = ''; if (prev) prev.hidden = true; this.err(f, 'Please choose a photo (JPG, PNG or HEIC).'); return; }
    if (prev) { try { prev.src = URL.createObjectURL(file); prev.hidden = false; } catch (e) {} }
  };
  Block.prototype.qty = function () {
    var f = this.form(), q = f && f.querySelector('[name=quantity]');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  };
  Block.prototype.addons = function () { // các khoản phụ thu đang chọn: {a: id biến thể, p: xu (tiền shop), once, k, v}
    var out = [];
    this.fields.forEach(function (f) {
      if (!shown(f)) return;
      var t = f.getAttribute('data-t'), k = f.getAttribute('data-k'), once = f.hasAttribute('data-once');
      if (f.hasAttribute('data-p') && vals(f).length) out.push({ a: +f.getAttribute('data-a'), p: +f.getAttribute('data-p'), once: once, k: k, v: t === 'upload' ? 'photo' : vals(f).join(', ') });
      (t === 'select' ? all('option:checked', f) : all('.hc-sw input:checked,.hc-rs input:checked', f)).forEach(function (o) {
        if (o.value && o.hasAttribute('data-p')) out.push({ a: +o.getAttribute('data-a'), p: +o.getAttribute('data-p'), once: once, k: k, v: o.value });
      });
    });
    return out;
  };
  Block.prototype.total = function () {
    var q = this.qty(), add = 0, box = this.el.querySelector('[data-hc-sum]');
    this.addons().forEach(function (a) { add += a.p * (a.once ? 1 : q); });
    if (!box) return;
    box.hidden = !add;
    if (!add) return;
    var f = this.form(), v = f && f.querySelector('[name=id]'), base = (this.prices[v && v.value] || 0) * q;
    var addShown = Math.round(add * rate());
    box.querySelector('[data-hc-add]').textContent = '+' + money(addShown) + '  ·  Total ' + money(base + addShown);
  };
  Block.prototype.err = function (f, msg) {
    var p = f.querySelector('[data-hc-err]');
    f.classList.toggle('is-err', !!msg);
    if (p) { p.textContent = msg; p.hidden = !msg; }
  };
  Block.prototype.validate = function () {
    var self = this, first = null;
    this.fields.forEach(function (f) {
      var t = f.getAttribute('data-t');
      if (t === 'group' || !shown(f)) return;
      var msg = '';
      if (f.hasAttribute('data-req') && !vals(f).length) msg = t === 'upload' ? 'Please upload your photo.' : (t === 'text' || t === 'textarea') ? 'Please fill this in.' : 'Please choose an option.';
      if (!msg && t === 'checks') { // số lựa chọn tối thiểu/tối đa như TEPO (tối thiểu chỉ áp khi ô bắt buộc hoặc khách đã chọn)
        var n = vals(f).length, mn = +f.getAttribute('data-mn') || 0, mx = +f.getAttribute('data-mx') || 0;
        if (mx && n > mx) msg = 'Please choose up to ' + mx + ' options.';
        else if (mn && n < mn && (n > 0 || f.hasAttribute('data-req'))) msg = 'Please choose at least ' + mn + (mn > 1 ? ' options.' : ' option.');
      }
      self.err(f, msg);
      if (msg && !first) first = f;
    });
    if (first) {
      var g = first.closest('details');
      if (g) g.open = true;
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var i = first.querySelector('textarea,input[type=text],select');
      if (i) try { i.focus({ preventScroll: true }); } catch (e) {}
    }
    return !first;
  };
  Block.prototype.say = function (msg) {
    if (W.T4SThemeSP && typeof W.T4SThemeSP.Notices === 'function') { try { W.T4SThemeSP.Notices(msg); return; } catch (e) {} }
    alert(msg);
  };

  /* ---------- thêm vào giỏ ---------- */
  function post(url, body, json) {
    var h = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
    if (json) { h['Content-Type'] = 'application/json'; body = JSON.stringify(body); }
    return fetch(url, { method: 'POST', headers: h, body: body, credentials: 'same-origin', hcInternal: true })
      .then(function (r) { return r.json().catch(function () { return { status: r.status, description: 'Network error' }; }); });
  }
  function shrink(file) { // ảnh quá nặng (>12MB) → thu còn cạnh dài 4000px, vẫn đủ nét để in
    if (!isFile(file) || file.size <= 12 * 1024 * 1024 || !W.createImageBitmap) return Promise.resolve(file);
    return W.createImageBitmap(file).then(function (bmp) {
      var s = Math.min(1, 4000 / Math.max(bmp.width, bmp.height)), c = D.createElement('canvas');
      c.width = Math.round(bmp.width * s); c.height = Math.round(bmp.height * s);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      return new Promise(function (res) {
        c.toBlob(function (b) { res(b ? new File([b], (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.92);
      });
    }).catch(function () { return file; });
  }
  function busy(btn, on) {
    if (!btn) return;
    if (on) { btn.__hcAria = btn.getAttribute('aria-disabled'); btn.setAttribute('aria-disabled', 'true'); }
    else if (btn.__hcAria === null || btn.__hcAria === undefined) btn.removeAttribute('aria-disabled');
    else btn.setAttribute('aria-disabled', btn.__hcAria);
    btn.classList.toggle('is--loading', on);
    all('.loading-overlay__spinner,.t4s-svg-spinner', btn).forEach(function (s) { s.hidden = !on; });
  }
  Block.prototype.add = function (btn, checkout) {
    var self = this, form = this.form();
    if (this.busy || !form) return;
    if (!this.validate()) return;
    this.busy = true;
    busy(btn, true);
    var fd = new FormData(form), q = this.qty();
    var group = 'hc' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var drop = [], files = [];
    fd.forEach(function (v, k) {
      if (!/^properties\[/.test(k)) return;
      if (v === '' || (isFile(v) && !v.size)) drop.push(k); else if (isFile(v)) files.push([k, v]);
    });
    drop.forEach(function (k) { fd.delete(k); });
    var adds = this.addons(), addCents = 0;
    if (adds.some(function (a) { return !(a.a > 0); })) { // cấu hình thiếu mã phụ thu → dừng TRƯỚC khi thêm gì (không để SP vào giỏ thiếu tiền)
      this.busy = false; busy(btn, false);
      this.say('Sorry, this option is temporarily unavailable. Please contact us.');
      return;
    }
    adds.forEach(function (a) { addCents += a.p * (a.once ? 1 : q); });
    fd.set('properties[_hc_group]', group);
    if (addCents) fd.set('properties[_hc_addon]', (addCents / 100).toFixed(2));
    // danh sách phụ thu phải có (ẩn với khách): [mã biến thể, giá xu, tính 1 lần?, chữ Option] — giỏ dùng để thêm lại dòng khách lỡ xoá,
    // CRM dùng để đối chiếu tiền phụ thu thật đã thu
    if (adds.length) fd.set('properties[_hc_adds]', JSON.stringify(adds.map(function (a) { return [a.a, a.p, a.once ? 1 : 0, a.k + ': ' + a.v]; })));
    Promise.all(files.map(function (p) { return shrink(p[1]).then(function (nf) { if (nf !== p[1]) fd.set(p[0], nf, nf.name); return nf; }); }))
      .then(function (fs_) {
        if (fs_.some(function (x) { return isFile(x) && x.size > 20 * 1024 * 1024; })) throw new Error('Your photo is too large (max 20 MB). Please choose a smaller photo.');
        return post(U_ADD, fd);
      })
      .then(function (r) {
        if (r.status || !r.key) throw new Error(r.description || r.message || 'Could not add to cart. Please try again.');
        if (!adds.length) return;
        var items = adds.map(function (a) {
          var p = { 'Option': a.k + ': ' + a.v, 'For': self.title, _hc_parent: group };
          if (a.once) p._hc_once = '1';
          return { id: a.a, quantity: a.once ? 1 : q, properties: p };
        });
        return post(U_ADD, { items: items }, true).then(function (r2) {
          if (!r2.status) { try { localStorage.setItem(FLAG, '1'); } catch (e) {} return; }
          return post(U_CHANGE, { id: r.key, quantity: 0 }, true).then(function () {
            throw new Error('Sorry, we could not add your options. Please try again.');
          });
        });
      })
      .then(function () {
        if (checkout) { W.location.href = ROOT + 'checkout'; return; }
        if (W.T4SThemeSP) D.dispatchEvent(new CustomEvent('cart:refresh:opend'));
        else W.location.href = ROOT + 'cart';
      })
      .catch(function (e) { self.say(e.message || 'Could not add to cart. Please try again.'); })
      .then(function () { self.busy = false; busy(btn, false); });
  };

  function blockFor(btn) {
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i], f = b.form();
      if (!f) continue;
      if (btn.form === f || f.contains(btn)) return b;
      if (btn.hasAttribute('data-action-atc') && b.prices.hasOwnProperty(btn.getAttribute('data-variant-id'))) return b;
    }
    return null;
  }
  D.addEventListener('click', function (e) { // chặn trước theme: nút chính + thanh mua dính của SP có ô custom
    var bn = e.target && e.target.closest && e.target.closest('[data-hc-buynow]');
    if (bn) {
      var b0 = blockFor(bn);
      if (b0) { e.preventDefault(); e.stopPropagation(); b0.add(bn, true); }
      return;
    }
    var btn = e.target && e.target.closest && e.target.closest('[data-atc-form],button[name="add"],[data-action-atc]');
    if (!btn) return;
    var b = blockFor(btn);
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if ((btn.disabled || btn.getAttribute('aria-disabled') === 'true') && !b.busy) { b.say('This option is sold out.'); return; }
    b.add(btn);
  }, true);
  D.addEventListener('submit', function (e) {
    for (var i = 0; i < blocks.length; i++) {
      if (e.target === blocks[i].form()) {
        e.preventDefault(); e.stopImmediatePropagation();
        blocks[i].add(e.target.querySelector('[data-atc-form],button[name="add"]'));
        return;
      }
    }
  }, true);

  /* ---------- giữ dòng phụ thu khớp SP chính khi khách sửa giỏ ---------- */
  var recoTimer;
  function reconcileSoon() { clearTimeout(recoTimer); recoTimer = setTimeout(reconcile, 400); }
  function reconcile() {
    return fetch(U_CART, { credentials: 'same-origin', hcInternal: true }).then(function (r) { return r.json(); }).then(function (cart) {
      var main = {}, spec = {}, title = {}, ups = {}, any = false, n = 0, have = {}, missing = [];
      cart.items.forEach(function (it) {
        var p = it.properties || {}, g = p._hc_group;
        if (!g) return;
        main[g] = (main[g] || 0) + it.quantity;
        title[g] = it.product_title || '';
        if (p._hc_adds && !spec[g]) { try { spec[g] = JSON.parse(p._hc_adds); } catch (e) {} }
      });
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (!p._hc_parent) return;
        any = true;
        var want = main[p._hc_parent] ? (p._hc_once ? 1 : main[p._hc_parent]) : 0;
        if (it.quantity !== want) { ups[it.key] = want; n++; }
        have[p._hc_parent + '|' + it.variant_id + '|' + (p.Option || '')] = true;
      });
      // khách lỡ xoá dòng phụ thu mà vẫn giữ SP chính → thêm lại đúng dòng đó (tuỳ chọn có phí phải có tiền đi kèm, như TEPO gộp 1 dòng)
      Object.keys(spec).forEach(function (g) {
        (spec[g] || []).forEach(function (s) {
          if (!s || !(s[0] > 0) || have[g + '|' + s[0] + '|' + s[3]]) return;
          var props = { 'Option': s[3], 'For': title[g], _hc_parent: g };
          if (s[2]) props._hc_once = '1';
          missing.push({ id: s[0], quantity: s[2] ? 1 : main[g], properties: props });
        });
      });
      if (!any && !missing.length) { try { localStorage.removeItem(FLAG); } catch (e) {} }
      if (!n && !missing.length) return;
      var step = n ? post(U_UPDATE, { updates: ups }, true) : Promise.resolve();
      return step.then(function () { return missing.length ? post(U_ADD, { items: missing }, true) : null; }).then(function () {
        try { localStorage.setItem(FLAG, '1'); } catch (e) {}
        if (/\/cart\/?$/.test(W.location.pathname)) W.location.reload();
        else D.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    }).catch(function () {});
  }
  var nativeFetch = W.fetch;
  W.fetch = function (u, init) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (!(init && init.hcInternal) && /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(url)) p.then(reconcileSoon, reconcileSoon);
    } catch (e) {}
    return p;
  };

  function init() {
    all('[data-hc]').forEach(function (el) { if (!el.__hc) { el.__hc = new Block(el); blocks.push(el.__hc); } });
    try { if (localStorage.getItem(FLAG)) reconcileSoon(); } catch (e) {}
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
